/* Native Shopify contact forms only. No submission interception or analytics payloads. */
document.querySelectorAll('.ldp-form form').forEach(form => {
  const reply = form.querySelector('[data-distinct-reply]');
  const phone = form.querySelector('[data-distinct-phone]');
  if (!reply || !phone) return;
  const sync = () => { phone.required = reply.value === 'Phone call' || reply.value === 'WhatsApp'; };
  reply.addEventListener('change', sync);
  sync();

  // Keep the first invalid field clear of the existing sticky header.
  let pendingInvalid = null;
  form.addEventListener('invalid', event => {
    if (pendingInvalid) return;
    pendingInvalid = event.target;
    requestAnimationFrame(() => {
      pendingInvalid.scrollIntoView({ block: 'center', inline: 'nearest' });
      pendingInvalid = null;
    });
  }, true);
});
